(() => {
  if (typeof jQuery === 'undefined') {
    throw new TypeError(
      "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.",
    );
  }
})();

export default jQuery;
